import { useEffect } from 'react'

export default function () {
  useEffect(() => {
    const links = document.querySelectorAll('link[rel="stylesheet"]')
    links.forEach((link) => {
      document.head.appendChild(link)
    })
  }, [])
}
